// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"f32eb30a","185":"a080b05a","268":"989502ed","354":"e3412cae","582":"47f1c894","627":"d297000a","657":"b19a1895","790":"f691a1ea","820":"d6156628","844":"3faafd54","940":"a6b27120"}[chunkId] + ".chunk.js";
};